import AOS from 'aos';
import { throttle, debounce } from 'underscore'; //https://underscorejs.org
import 'slick-carousel/slick/slick.min.js';
// import Modal from 'bootstrap/js/dist/modal';


// custom jquery below
jQuery(document).ready(function ($) {
    'use strict';

    // FADE IN CONTENT ON PAGE LOAD
    // setTimeout(function () {
    //     $('body').addClass('delayfade');
    // }, 300);

    // content spacing for fixed header
    if ( $('body').hasClass('home') ) {
        // do nothing
    } else {

        let contentTopSpacing = function() {
            let headingHeight = $('header.site-header').outerHeight();

            $('main').css('padding-top', headingHeight);
        }

        contentTopSpacing();

        $(window).on( 'resize', function() {
            contentTopSpacing();
        });

    };


    // MOBILE NAV
    $(document).on('click', 'a#menu-toggle', function(){

        if ( $(this).hasClass('clicked') ) {
            $(this).removeClass('clicked');
            $('#mobile-menu').fadeOut(200);
            $('body').removeClass('mobile-menu-open');
        } else {
            $(this).addClass('clicked');
            $('#mobile-menu').fadeIn(200);
            $('body').addClass('mobile-menu-open');
        }
    });
    $('.mobile-menu .menu-item-has-children').each(function(){
       let submenu = $(this).find('.sub-menu');
       $(submenu).slideUp();
       $(this).click(function(){
           if( $(this).hasClass('clicked') ) {
               $(this).removeClass('clicked');
               $(submenu).slideUp(300);
           } else {
               $(this).addClass('clicked');
               $(submenu).slideDown(300);
           }

       });
    });
    $('.menu li a[href="#"]').click(function(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    });




    // HOME PAGE TICKER ANIMATION
    $('.ticker').each(function(){
        $(this).slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
            draggable: false,
        });
    });

    let header = $(".site-header");
    $(window).on("load scroll", function() {
        let scroll = $(window).scrollTop();

        if (scroll >= 10) {
            header.addClass("header-alt");
        } else {
            header.removeClass("header-alt");
        }
    });

    // animate on scroll init - https://michalsnik.github.io/aos/
    // ** IF USING SLICK SLIDER, AOS MUST BE INITIALIZED AFTER ANY/ALL SLICK SLIDERS **
    AOS.init({
        offset: 200
    });

});
